import { ServiceOrderStatusEnum, PriorityEnum, SlaServiceTypeEnum } from 'src/enumerators';
import { IRest } from './rest.interface';

export class ServiceOrder implements IRest {
  className: 'Ordem de Serviço';

  id: string;
  name: string;
  createdBy: any;
  createdAt: Date;

  contractId: string;
  projectId: string;

  status: ServiceOrderStatusEnum;
  estimatedCompletionDate: Date;

  serviceOrderFiles: any[];
  createdByMemberId: string;

  description?: string;
  requester: string;
  contactChannel: string;

  latitude?: number;
  longitude?: number;
  address?: string;
  contractedCompanyId?: string;

  serviceType?: SlaServiceTypeEnum | string;
  priority?: PriorityEnum | string;
  slaRuleId?: string;
  followSla?: boolean;

  progress: ServiceOrderSignalingsProgress;

  constructor(data?: any) {
    if (data) this.Deserialize(data);
  }

  Serialize() {
    const out = {
      id: this.id || undefined,
      name: this.name,

      contractId: this.contractId,
      projectId: this.projectId,

      createdAt: this.createdAt,
      serviceOrderFiles: this.serviceOrderFiles,

      description: this.description,
      requester: this.requester,
      contactChannel: this.contactChannel,

      status: this.status,
      estimatedCompletionDate: this.estimatedCompletionDate,

      latitude: this.latitude ?? undefined,
      longitude: this.longitude ?? undefined,
      address: this.address ?? undefined,

      contractedCompanyId: this.contractedCompanyId || undefined,

      serviceType: this.serviceType ?? undefined,
      priority: this.priority ?? undefined,
      slaRuleId: this.slaRuleId ?? undefined,
      followSla: this.followSla ?? true,
    };
    return out;
  }

  Deserialize(data: any) {
    this.id = data['id'] || '';
    this.name = data['name'] || '';
    this.createdAt = data['createdAt'] || new Date(2000, 1, 1);

    this.contractId = data['contractId'] || '';
    this.projectId = data['projectId'] || undefined;

    this.status = data['status'] || ServiceOrderStatusEnum.Open;
    this.estimatedCompletionDate = data['estimatedCompletionDate'] || null;

    this.createdByMemberId = data['createdByMemberId'] || '';

    this.description = data['description'] || '';
    this.requester = data['requester'] || '';
    this.contactChannel = data['contactChannel'] || '';

    this.serviceOrderFiles = data['serviceOrderFiles'] || [];
    this.contractedCompanyId = data['contractedCompanyId'] || undefined;

    const lat = data['latitude'];
    const lng = data['longitude'];
    this.latitude = lat !== undefined && lat !== null && lat !== '' ? Number(lat) : undefined;
    this.longitude = lng !== undefined && lng !== null && lng !== '' ? Number(lng) : undefined;
    this.address = data['address'] || '';

    this.serviceType = data['serviceType'] ?? '';
    this.priority = data['priority'] ?? '';
    this.slaRuleId = data['slaRuleId'] ?? undefined;
    if (data['followSla'] === undefined || data['followSla'] === null) {
      this.followSla = true;
    } else {
      const raw = data['followSla'];
      this.followSla = raw === true || raw === 'true' || raw === 1 || raw === '1';
    }

    return this;
  }
}

export class ServiceOrderSignalingsProgress implements IRest {
  className: 'Progresso da Ordem de Serviço';

  serviceOrderId: string;
  activitiesSignalingsQuantity: number;
  signalingsQuantity: number;

  constructor(data?: any) {
    if (data) this.Deserialize(data);
  }

  Serialize() {
    const out = {
      serviceOrderId: this.serviceOrderId || undefined,
      activitiesSignalingsQuantity: this.activitiesSignalingsQuantity,
      signalingsQuantity: this.signalingsQuantity,
    };
    return out;
  }

  Deserialize(data: any) {
    this.serviceOrderId = data['serviceOrderId'] || undefined;
    this.activitiesSignalingsQuantity = data['activitiesSignalingsQuantity'] || 0;
    this.signalingsQuantity = data['signalingsQuantity'] || 0;
    return this;
  }
}
